import { createCustomContext } from "../utils/CreateCustomContext"
interface IAnimationState {
  moneyAnimations: IMoneyTransferAnimation[]
}
const initialState: IAnimationState = {
  moneyAnimations: [],
}

function setState(
  state: IAnimationState,
  newState: Partial<IAnimationState>
): IAnimationState {
  return { ...state, ...newState }
}

export const setMoneyAnimationAsStarted = (
  state: IAnimationState,
  animationId: string
): IAnimationState => {
  return {
    ...state,
    moneyAnimations: state.moneyAnimations.map((anim) =>
      anim.id === animationId ? { ...anim, started: true } : anim
    ),
  }
}

const functions = {
  setMoneyAnimationAsStarted,
  setState,
}

const { Context, Provider, useContextHook } = createCustomContext<
  IAnimationState,
  typeof functions
>({
  initialState,
  functions,
})

export const AnimationContextProvider = Provider
export const useAnimationContext = useContextHook
